import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=0ea0b3e0&"
import script from "./AgentForm.vue?vue&type=script&lang=ts&"
export * from "./AgentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports